export const APP_DATA = {
  FREE_TRIAL_DAYS: 3,
  ENTRY_PRICE: 1,
  ENTRY_DAYS: 14,
};

export const PLANS_PRICING = {

  STARTER: {
    MONTHLY: 19.99,
    YEARLY: 227.99,
  },
  GROWTH: {
    MONTHLY: 29.99,
    YEARLY: 341.99,
  },
  PRO: {
    MONTHLY: 69.99,
    YEARLY: 797.99,
  },
  ENTERPRISE: {
    MONTHLY: 399.99,
    YEARLY: 4559.99,
  },
};

export const TRANSACTION_FEES = {
  STARTER: {
    CARD: 3.0,
    COD: 0.0,
  },
  GROWTH: {
    CARD: 2.0,
    COD: 0.0,
  },
  PRO: {
    CARD: 1.0,
    COD: 0.0,
  },
  ENTERPRISE: {
    CARD: 0.5,
    COD: 0.0,
  },
};

export const STAFF_ACCOUNTS = {
  STARTER: 0,
  GROWTH: 5,
  PRO: 10,
  ENTERPRISE: 20,
};

// export const THRESHOLD_SYSTEM = {
//   START: {
//     AMOUNT: 15,
//     COVERS_SALES: 1000,
//   },
//   LEVELS: [
//     { threshold: 15, covers: 1000, description: "All sellers start here" },
//     {
//       threshold: 30,
//       covers: 5000,
//       description: "After first successful $30 payment",
//     },
//     {
//       threshold: 60,
//       covers: 10000,
//       description: "After paying the $100 threshold",
//     },
//     {
//       threshold: 120,
//       covers: 20000,
//       description: "Based on consistent payment history",
//     },
//   ],
//   INACTIVE_RESET_DAYS: 60,
//   ENTERPRISE_CUSTOM: true,
// };
